import { postRequest } from "../apiHelpers";
import {
	getLifeInsuranceClaiming, approveRejectLifeInsuranceClaim, getExportNearlyExpired,
	getVehicleInsuranceClaiming,
	paymentDebitURL,
	paymentCheckByBillNumberURL
} from "../pathApi";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const callGetLifeInsuranceClaiming = createAsyncThunk(getLifeInsuranceClaiming, async (body) => {
	try {
		const response = await postRequest({ url: getLifeInsuranceClaiming, data: body });
		return response;
	} catch (error) {
		throw error;
	}
});
export const callGetVehicleInsuranceClaiming = createAsyncThunk(getVehicleInsuranceClaiming, async (body) => {
	try {
		const response = await postRequest({ url: getVehicleInsuranceClaiming, data: body });
		return response;
	} catch (error) {
		throw error;
	}
});

export const callApproveRejectLifeInsuranceClaim = createAsyncThunk(approveRejectLifeInsuranceClaim, async (body) => {
	try {
		const response = await postRequest({ url: approveRejectLifeInsuranceClaim, data: body });
		return response;
	} catch (error) {
		throw error;
	}
});



// Dashboard contract list uses the same canonical endpoint as the Near Expired report.
// Kept as a plain async service (instead of Redux thunk) so the dashboard can manage
// its own inline loading/error state without opening the global SweetAlert loader.
export const getDashboardContractList = async (body) => {
	try {
		return await postRequest({
			url: getExportNearlyExpired,
			data: body,
			showLoading: false,
			showAlert: false,
		});
	} catch (error) {
		throw error;
	}
};
export const callGetExportNearlyExpired = createAsyncThunk(getExportNearlyExpired, async (body) => {
	try {
		const response = await postRequest({ url: getExportNearlyExpired, data: body });
		return response;
	} catch (error) {
		throw error
	}
});
export const callPaymentDebit = createAsyncThunk(paymentDebitURL, async (body) => {
	try {
		const response = await postRequest({ url: paymentDebitURL, data: body });
		return response;
	} catch (error) {
		throw error
	}
});
export const callPaymentCheckByBillNumber = createAsyncThunk(paymentCheckByBillNumberURL, async (body) => {
	try {
		const response = await postRequest({ url: paymentCheckByBillNumberURL, data: body, showLoading: false, showAlert: false });
		return response;
	} catch (error) {
		throw error
	}
});